import { atom } from 'jotai';

export const isWorkerNavOverlayOpenAtom = atom<boolean>(false);
